import React from 'react';
import { Row, Col } from 'reactstrap';
import ReactAudioPlayer from 'react-audio-player';
import PropTypes from 'prop-types';
import capitalize from 'lodash.capitalize';
import sortedStops from './sortedStops';

class AudioStops extends React.Component {
  constructor(props) {
    super(props);

    // Audio player refs
    // These allow us to stop the player on language switch
    sortedStops.forEach((stop) => {
      this[`playerRef${stop.order}`] = React.createRef();
    });

    this.clickHandler = this.clickHandler.bind(this);
  }

  componentWillReceiveProps() {
    sortedStops.forEach((stop) => {
      this[`playerRef${stop.order}`].audioEl.pause();
      this[`playerRef${stop.order}`].audioEl.currentTime = 0;
    });
  }

  clickHandler() {
    sortedStops.forEach((stop) => {
      this[`playerRef${stop.order}`].audioEl.pause();
      this[`playerRef${stop.order}`].audioEl.currentTime = 0;
    });
  }

  render() {
    const gcsPrefix = 'https://storage.googleapis.com/ultimatedinos/';
    return (
      <Row className="audio-content">
        {sortedStops.map(stop =>
          (
            <Col
              key={stop.order}
              className="mb-3 audio-item"
              sm={12}
              md={6}
              lg={6}
            >
              <h2>{stop.order} - {stop[`title${capitalize(this.props.language)}`]}</h2>
              <ReactAudioPlayer
                src={`${gcsPrefix}${stop.audioFile}-${this.props.language}.mp3`}
                ref={(element) => {
                  this[`playerRef${stop.order}`] = element;
                }}
                controls
              />
            </Col>
          ))
        }
      </Row>
    );
  }
}

AudioStops.propTypes = {
  language: PropTypes.string,
};

AudioStops.defaultProps = {
  language: 'en',
};

export default AudioStops;



// WEBPACK FOOTER //
// ./src/AudioStops.js